import {
  Component,
  Inject,
  Injector,
  forwardRef,
  ViewEncapsulation,
  ElementRef,
  Renderer,
  Optional,
  NgModule
} from '@angular/core';

import { CommonModule } from '@angular/common';

import { OListItemComponent } from '../list-item/o-list-item.component';
import { OListItemCardRenderer } from './o-list-item-card-renderer.class';
import { OSharedModule } from '../../../shared';

export const DEFAULT_INPUTS_O_LIST_ITEM_CARD = [
  ...OListItemCardRenderer.DEFAULT_INPUTS_O_CARD_RENDERER
];

export const DEFAULT_OUTPUTS_O_LIST_ITEM_CARD = [
  ...OListItemCardRenderer.DEFAULT_OUTPUTS_O_CARD_RENDERER
];



export class OListItemCardComponent extends OListItemCardRenderer {

  constructor(
    elRef: ElementRef,
    _renderer: Renderer,
    _injector: Injector,
      _listItem: OListItemComponent
  ) {
    super(elRef, _renderer, _injector, _listItem);
  }

  ngAfterViewInit() {
    this.modifyMdListItemElement();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-list-item-card',
  template: `
    <md-card fxLayout="column" fxLayoutAlign="center center">
      <md-card-title-group >
        <img src="{{ image }}" [class.mat-card-sm-image]="compareListHeight('small')" [class.mat-card-md-image]="compareListHeight('medium')"
          [class.mat-card-lg-image]="compareListHeight('large')">
        <md-card-title *ngIf="title !== undefined"> {{ title }}</md-card-title>
        <md-card-subtitle *ngIf="subtitle !== undefined"> {{ subtitle }}</md-card-subtitle>
      </md-card-title-group>
      <md-card-actions>
        <button md-button *ngIf="action1Text !== undefined" (click)="onAction1ButtonClick($event)">{{ action1Text }}</button>
        <button md-button *ngIf="action2Text !== undefined" (click)="onAction2ButtonClick($event)">{{ action2Text }}</button>
      </md-card-actions>
    </md-card>
  `,
  styles: [`
    .mat-list .mat-list-item.o-card-item .mat-list-item-content{height:auto}.o-list-item-card md-card,.o-list-item-card md-card-actions{width:100%}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_LIST_ITEM_CARD
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_LIST_ITEM_CARD
  ],
  encapsulation: ViewEncapsulation.None,
  host: {
    'layout-padding': '',
    '[class.o-custom-list-item]': 'true',
    '[class.o-list-item-card]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
{type: Injector, },
{type: OListItemComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OListItemComponent), ] }, ]},
];
}


export class OListItemCardModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OListItemCardComponent],
  imports: [
    OSharedModule,
    CommonModule
  ],
  exports: [OListItemCardComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
